import { BtnLink } from '@mi-front/ui';
import { Box, Button, Tooltip } from '@mui/material';
import { ReactNode } from 'react';

export function RowAction({
  onClick,
  title,
  icon,
  children,
  link,
}: {
  onClick?: () => void;
  title?: ReactNode;
  icon?: React.ReactNode;
  children?: ReactNode;
  link?: string;
}) {
  const content = link ? (
    <BtnLink size="xs" to={link} openInNewTab icon={icon} />
  ) : (
    <Button variant="outlined" color="primary" size="small" onClick={onClick} startIcon={icon}>
      {children}
    </Button>
  );

  return (
    <Tooltip title={title}>
      <Box component="span" sx={{ display: 'inline-block' }}>
        {content}
      </Box>
    </Tooltip>
  );
}
